import BEM from 'bem.js';

const BLOCK_FORM = 'form';

const ELEMENT_COUNTRY = 'country';
const ELEMENT_ADDRESS = 'address';

const MODIFIER_HIDDEN = 'hidden';


class CountryChanger {
    constructor() {
        this.country_field = BEM.getBEMNode(BLOCK_FORM, ELEMENT_COUNTRY);
        this.address_fieldset = BEM.getBEMNode(BLOCK_FORM, ELEMENT_ADDRESS);

        this.addChange();
        this.changeInputs();
    }

    addChange() {
        if(this.country_field) {
            this.country_field.addEventListener('change', (e) => {
                this.changeInputs();
            });
        }
    }

    changeInputs() {
        if(this.address_fieldset) {
            if(this.address_fieldset.dataset.countryid == this.country_field.value){
                BEM.removeModifier(this.address_fieldset, MODIFIER_HIDDEN);
            } else {
                BEM.addModifier(this.address_fieldset, MODIFIER_HIDDEN);
            }
        }
    }
}


new CountryChanger();



// WEBPACK FOOTER //
// ./src/my_artis/js/components/register.js